import { formatDate } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { BackendApiService } from 'src/app/service/backendapi.service';
import { CountryCodesService } from 'src/app/service/country-codes.service';
import { EndpointsService } from 'src/app/service/endpoints.service';
import { CountryDetails } from '../CountryDetails';
import { RoamersSegment } from '../RoamersSegment';

@Component({
  selector: 'app-rrms-active-deactive-msisdn.component',
  templateUrl: './rrms-active-deactive-msisdn.component.html',
  styleUrls:  ['./rrms-active-deactive-msisdn.component.scss']
})
export class RrmsActiveDeactiveMsissdnComponent implements OnInit, OnDestroy {

  roamerSegmentForm: FormGroup;
  private dateToString = (date: any) => `${date.year}-${date.month}-${date.day}`;

  country = []
  network = []
  dataSource = []
  VPMNCountry = []
  VPMNnetwork = []
  VPMNtadig = []
  HPMNtadig = []
  submitted = false;
  showTable: boolean;
  messageCategory = ["MessageCategory1", "MessageCategory2", "MessageCategory3"]
  vpmnCountryList: any;
  vpmnNetworkList: any;
  vpmnTadigList: any;
  ctypelist=["deactive","active"]
  callVPMNNetwork: boolean;

  countryCodeCheck: any;
  map: Map<string, string>;
  searchSelected: boolean;
  constructor(private formBuilder: FormBuilder, private endpointsService: EndpointsService,
    private countryCodesService: CountryCodesService,
    private backendApiService: BackendApiService, private spinnerService: Ng4LoadingSpinnerService) { }

  ngOnDestroy() {
  }

  ngOnInit() {
    this.createRoamersSegmentForm()
    this.getVPMNCountryDetails()
    //this.storeAnalytics();
    this.map = this.countryCodesService.getCountryCodes();
  }

  createRoamersSegmentForm() {
    this.roamerSegmentForm = this.formBuilder.group({
      //HPMNtadig: [sessionStorage.getItem('homeTadg')],
     // country: [sessionStorage.getItem('homeCountryNameWithOp')],
     // network: [sessionStorage.getItem('homeOp')],
    //  msgCatergory: ['all'],
      datatypelist:['deactive'],
    //  VPMNCountry: [''],
     // VPMNnetwork: [''],
      // msisdn: ['', [Validators.maxLength(12),Validators.pattern("^[0-9]*$"), this.countryCodeValidator]],
      msisdn: ['', [Validators.minLength(12), Validators.maxLength(12), Validators.required, Validators.pattern("^[0-9]*$"), this.countryCodeValidator.bind(this)]],
      
    //  VPMNtadig: [''],
    //  startDate: [, [Validators.required]],
     // endDate: [, [Validators.required]],
      
    });
  }

  changeDateEvent(targetCalendarId: any) {
    targetCalendarId.toggle();
  }

  search() {
    
    this.searchSelected = true;
    this.submitted = true;
    if(this.roamerSegmentForm.invalid){
      return;
    }
    this.getSearch();
   
  }
  
  getSearch(){

    if (this.roamerSegmentForm.invalid) {
      if (!(this.roamerSegmentForm.get('msisdn').value || this.roamerSegmentForm.get('datatypelist').value)) {
        this.spinnerService.hide();
        alert("Please provide values for Type or MSISDN")
      }
      return;
    }
  
    let url = this.endpointsService.ECOWAS_ACTIVE_DEACTIVE_API;
    // let countryData = this.roamerSegmentForm.get('country').value;
    // let countryData = this.roamerSegmentForm.get('VPMNCountry').value;
    // if (countryData) {
    //   url += "&country=" + countryData.trim()
    // }
    // let networkData = this.roamerSegmentForm.get('network').value;
    // let networkData = this.roamerSegmentForm.get('VPMNnetwork').value;
    // if (networkData) {
    //   url += "&network=" + networkData
    // }
    // let tadigData = this.roamerSegmentForm.get('HPMNtadig').value;
    // let tadigData = this.roamerSegmentForm.get('VPMNtadig').value;
    // if (tadigData) {
    //   url += "&tadig=" + tadigData
    // }
    // let msgCatergory = this.roamerSegmentForm.get('msgCatergory').value;
    // if (msgCatergory) {
    //   url += "&messageCategory=" + msgCatergory
    // }
    // let startDate = this.roamerSegmentForm.get('startDate').value;
    // if (startDate) {
    //   url += "&startDate=" + this.dateFormate(this.roamerSegmentForm.value.startDate);
    // }
    // let endDate = this.roamerSegmentForm.get('endDate').value;
    // if (endDate) {
    //   url += "&endDate=" + this.dateFormate(this.roamerSegmentForm.value.endDate);
    // }

    let ctype = this.roamerSegmentForm.get('datatypelist').value;
    if (ctype) {
      url += "&ctype=" + ctype;
    }

    let msisdn = this.roamerSegmentForm.get('msisdn').value;
    if (msisdn) {
      url += "&msisdn=" + msisdn;
    }
    // let msidn = this.roamerSegmentForm.get('msidn').value;
    // if (msidn) {
    //   url += "&msisdn=" + msidn
    // }
    url += "&userOrgId=" + sessionStorage.getItem('userOrgId');
    
    this.backendApiService.callToApi(url).subscribe(res => {
      if(res){
        this. dataSource = res;
      }
      if (res == true)
      {
        this.storeAnalytics();
        alert("Offer "+ctype+" Successfully");
      }
      if (res == false)
      {
        alert("Offer Not "+ctype+"");
      }
      if (res == 'offer_already_deleted') {
        alert("Offer Already"+ctype+"");
      }
      if (res == 'offer_not_exist') {
        alert('Offer Does Not Exist');
      }
      this.showTable = true;
    });

}

countryCodeValidator(control: AbstractControl): { [key: string]: boolean } | null {
  if (control.value.length >= 12) {
    let map = new Map();
    map.set('Ghana', '233');
    map.set('Liberia', '231');
    map.set('Guinea Bissau', '245');
    map.set('Guinea', '224');
    map.set('Benin', '229');
    map.set('CIV', '225');
    map.set('Nigeria', '234');
    map.set('Congo-B', '242');
    map.set('Cameroon', '237');
    let v = control.value + "";
    let countryCode = v.substr(0, 3);
    let country = sessionStorage.getItem('homeCountry').trim();
    
    if (map.get(country)) {
      if (parseInt(countryCode) !== parseInt(map.get(country))) {
        return { 'countryCode': true };
      }
    }
  }
  return null;
}

  getCountryDetails() {
    this.backendApiService.callToApi(this.endpointsService.COUNTRY_DETAILS).subscribe(res => {
      this.country = res;
    });
  }

  networkValues() {
    this.getNetworkDetails()
  }

  getNetworkDetails() {
    let cntry = this.roamerSegmentForm.get('country').value.split("_")[1]
    
    this.backendApiService.callToApi(this.endpointsService.NETWORK_DETAILS
      + "&country=" + cntry)
      .subscribe(res => {
        this.network = res;
      });
  }

  async getVPMNCountryDetails() {
    const apiUrl = this.endpointsService.COUNTRY_DETAILS + '&userName=' + sessionStorage.getItem('ecowas_user_name');
    this.backendApiService.callToApi(apiUrl).subscribe(response => {
      this.vpmnCountryList = response;
    });
  }

  getVpmnNetworkAccordingToCountry(event: any) {
    if (event.target.value === 'ALL') {
      this.roamerSegmentForm.controls.vpmnNetwork.setValue('ALL', { onlySelf: true });
    } else {
      this.getVpmnNetworkList(event.target.value).then();
    }
  }

  async getVpmnNetworkList(country: string) {
    const apiUrl1 = this.endpointsService.URL_GET_OPERATOR_LIST_BY_COUNTRY +
      '&userName=' + sessionStorage.getItem('ecowas_user_name') + '&country=' + country;
    this.backendApiService.callToApi(apiUrl1).subscribe(response => {
      this.vpmnNetworkList = response;
      if (this.vpmnNetworkList && this.vpmnNetworkList.length > 0) {
        this.roamerSegmentForm.controls.VPMNnetwork.setValue(response[0].operator, { onlySelf: true });
      }
      this.getTadig();
    });
  }


  getTadig() {
    if(this.roamerSegmentForm.controls.VPMNCountry.value == '' || this.roamerSegmentForm.controls.VPMNnetwork.value == ''){
      this.vpmnTadigList = [];
      this.roamerSegmentForm.get('VPMNtadig')
          .setValue('', {onlySelf: true});
    }
    else{
    this.backendApiService.callToApi(
      this.endpointsService.URL_GET_CAMPAIGN_TADIG + '&country=' + this.roamerSegmentForm.get('VPMNCountry').value +
      '&operator=' + this.roamerSegmentForm.get('VPMNnetwork').value).
      subscribe(response => {
        if (response.length === 0) {
          return;
        }
        this.vpmnTadigList = response;
        this.roamerSegmentForm.get('VPMNtadig')
          .setValue(response[0].tapCode, {onlySelf: true});
      });
    }
  }

  get f() {
    return this.roamerSegmentForm.controls;
  }

  dateFormate(date) {
    return formatDate(date, 'yyyy-MM-dd HH:mm', 'en');
  }

  reset(){
    this.spinnerService.show();
    this.createRoamersSegmentForm();
    
    this.searchSelected = false;
    this.showTable = false;
    this.storeAnalytics1();
  }

  async storeAnalytics() {
    
    const apiUrl1 = this.endpointsService.CENTRY_LOG +
      'userName=' + sessionStorage.getItem('ecowas_user_name') + '&action=Reports' + '&module=rrms delete offer' + '&operation=delete offer'+ '&opname=submit' +'&opvalue='+ this.roamerSegmentForm.get('msisdn').value;
    this.backendApiService.callToApi(apiUrl1).subscribe(response => {
       console.log(response);
    });

  }
  storeAnalytics1() {
    
    const apiUrl1 = this.endpointsService.CENTRY_LOG +
      'userName=' + sessionStorage.getItem('ecowas_user_name') + '&action=Reports' + '&module=rrms delete offer' + '&operation=reset';
    this.backendApiService.callToApi(apiUrl1).subscribe(response => {
       console.log(response);
    });

  }

}
